import PropTypes from "prop-types";
import { createContext, useContext, useMemo, useState } from "react";
import { createPortal } from "react-dom";

// Lets a page place its own icon buttons in the NavBar's right-hand group,
// next to the contact button, while keeping state and handlers in the page.
const NavBarActionsContext = createContext({ slot: null, setSlot: () => {} });

export function NavBarActionsProvider({ children }) {
  const [slot, setSlot] = useState(null);
  const value = useMemo(() => ({ slot, setSlot }), [slot]);
  return (
    <NavBarActionsContext.Provider value={value}>
      {children}
    </NavBarActionsContext.Provider>
  );
}

NavBarActionsProvider.propTypes = {
  children: PropTypes.node,
};

/** Rendered once by the NavBar; adds no box, so an empty slot adds no gap. */
export function NavBarActionsSlot() {
  const { setSlot } = useContext(NavBarActionsContext);
  return <div ref={setSlot} className="contents" />;
}

/** Portals into the NavBar when it is mounted, otherwise renders `fallback`. */
export function NavBarActions({ children, fallback = null }) {
  const { slot } = useContext(NavBarActionsContext);
  return slot ? createPortal(children, slot) : fallback;
}

NavBarActions.propTypes = {
  children: PropTypes.node,
  fallback: PropTypes.node,
};
